import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-flex;\n      line-height: normal;\n    "])));
  },
  wrappedChildren: function wrappedChildren() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: flex;\n    "])));
  },
  fixed: function fixed() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      flex-shrink: 0;\n      display: inline-block;\n    "])));
  },
  stretch: function stretch() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      flex-grow: 1;\n      flex-shrink: 1;\n    "])));
  },
  stretchFallback: function stretchFallback() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      flex-basis: 100%;\n    "])));
  },
  item: function item() {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      margin-left: -1px;\n    "])));
  },
  itemFirst: function itemFirst() {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      margin-left: 0;\n    "])));
  }
});